import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import React from "react";
import AssetImage from "./Image";
import AssetVideo from "./Video";
import { jsx as _jsx } from "react/jsx-runtime";
export { AssetImage, AssetVideo };

/**
 * @returns {input is import("./index").AssetProps}
 */
export function isAssetProps(input) {
  return typeof input === "object" && input.hasOwnProperty("versions") && input.hasOwnProperty("mimeType");
}

/**
 * @returns {mimeType is import("./index").SupportedVideoMimeTypes}
 */
export function isMimeTypeVideo(mimeType) {
  return mimeType.startsWith("video");
}

/**
 * @returns {mimeType is import("./index").SupportedImageMimeTypes}
 */
export function isMimeTypeImage(mimeType) {
  return mimeType.startsWith("image");
}

/**
 * @type {import("./index").Asset}
 */
export var Asset = function Asset(_ref) {
  var className = _ref.className,
    mimeType = _ref.mimeType,
    versions = _ref.versions,
    _ref$imageProps = _ref.imageProps,
    imageProps = _ref$imageProps === void 0 ? {} : _ref$imageProps,
    _ref$videoProps = _ref.videoProps,
    videoProps = _ref$videoProps === void 0 ? {} : _ref$videoProps;
  if (!mimeType) {
    return null;
  }
  if (isMimeTypeImage(mimeType)) {
    return /*#__PURE__*/_jsx(AssetImage, _objectSpread(_objectSpread({
      className: className
    }, _objectSpread({
      responsive: true
    }, imageProps)), {}, {
      versions: versions
    }));
  }
  if (isMimeTypeVideo(mimeType)) {
    return /*#__PURE__*/_jsx(AssetVideo, _objectSpread(_objectSpread({
      className: className
    }, videoProps), {}, {
      mimeType: mimeType,
      versions: versions
    }));
  }
};
export default Asset;
//# sourceMappingURL=index.js.map